import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "a",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.8 20.4c-.45 0-.83-.154-1.138-.462A1.549 1.549 0 0 1 4.2 18.8V5.7c0-.45.154-.829.462-1.138A1.549 1.549 0 0 1 5.8 4.1h6.325v1.3H5.8c-.067 0-.133.033-.2.1s-.1.134-.1.2v13.1c0 .067.033.133.1.2s.133.1.2.1h6.325v1.3H5.8Zm10.525-4.675L15.4 14.8l1.9-1.9H9.725v-1.3H17.3l-1.9-1.9.925-.926L19.8 12.25l-3.475 3.475Z",
    fill: "#0D346F"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }